import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const currentLang = i18n.language;

  const switchLanguage = (lang) => {
    if (lang === 'en') {
      navigate('/en');
    } else {
      navigate('/');
    }
  };

  return (
    <div className="language-switcher">
      <button
        className={`language-btn ${currentLang === 'nl' ? 'active' : ''}`}
        onClick={() => switchLanguage('nl')}
      >
        NL
      </button>
      <button
        className={`language-btn ${currentLang === 'en' ? 'active' : ''}`}
        onClick={() => switchLanguage('en')}
      >
        EN
      </button>
    </div>
  );
}

export default LanguageSwitcher;
